function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return <svg viewBox="0 0 32 31" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M1 0h30c.553 0 1 .392 1 .875v5.25c0 .484-.447.875-1 .875H1c-.552 0-1-.391-1-.875V.875C0 .392.448 0 1 0M1 12h30c.553 0 1 .392 1 .875v5.25c0 .484-.447.875-1 .875H1c-.552 0-1-.391-1-.875v-5.25C0 12.392.448 12 1 12M1 24h30c.553 0 1 .392 1 .875v5.25c0 .484-.447.875-1 .875H1c-.552 0-1-.391-1-.875v-5.25C0 24.392.448 24 1 24" /></svg>;
});